module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/idos-472ab25d7e17c10d271c196b831d89b4.png";